import { Pipe, PipeTransform } from '@angular/core';
import { DEFAULT_ERROR_MESSAGE, EMAIL_ERROR_MESSAGE } from '@lx/shared/errors';

@Pipe({
  standalone: true,
  name: 'lxEmailError',
})
export class EmailErrorPipe implements PipeTransform {
  transform(email: string): string {
    return email ? EMAIL_ERROR_MESSAGE : DEFAULT_ERROR_MESSAGE;
  }
}
